import { useEffect, useState } from "react";

import ButtonIconH from "../../components/ButtonIconH";
import CentralCatalogParametersSection from "./CentralCatalogParametersSection";

import "../css/CentralCatalogParametersPopup.css";

const esValorValido = (parametro, valor) => {
  if (parametro.TipoValor === "Desplegable") return valor !== "";
  return valor !== "" && !isNaN(parseFloat(valor));
};

const formatValorGuardado = (parametro, valor) => {
  if (parametro.TipoValor === "Desplegable") {
    return (
      parametro.Opciones?.find((o) => o.CodigoOpcion === valor)?.Opcion ??
      valor
    );
  }

  const numDecimales =
    parametro.NumDecimales === 0 ? "" : parametro.NumDecimales;
  const numValor = parseFloat(valor);

  if (numDecimales !== "" && !isNaN(numValor)) {
    return numValor.toFixed(parseInt(numDecimales, 10)).replace(".", ",");
  }

  return String(valor).replace(".", ",");
};

export default ({
  show,
  parametros = [],
  onAccept,
  onCancel,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [valores, setValores] = useState({});

  useEffect(() => {
    if (show) setValores({});
  }, [show]);

  const puedeAceptar = parametros.every(
    (parametro) =>
      !parametro.Requerido ||
      esValorValido(parametro, valores[parametro.CodigoEdi] ?? ""),
  );

  const buildParametrosGuardados = () =>
    parametros
      .map((parametro) => {
        const valor = valores[parametro.CodigoEdi] ?? "";
        return {
          CodigoEdi: parametro.CodigoEdi,
          Nombre: parametro.Nombre,
          UnidadesMedida: parametro.UnidadesMedida,
          Valor: valor === "" ? "" : formatValorGuardado(parametro, valor),
        };
      })
      .filter((parametro) => parametro.Valor !== "");

  return (
    show && (
      <div className="popup-container popup-normal popup-central-catalog-parameters">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">Parámetros</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={onCancel}
            />
          </div>
          <div className="popup-body">
            <div className="popup-container-block">
              {parametros.map((parametro, index) => (
                <CentralCatalogParametersSection
                  key={index}
                  parametro={parametro}
                  valor={valores[parametro.CodigoEdi] ?? ""}
                  onChange={(valor) =>
                    setValores((prev) => ({
                      ...prev,
                      [parametro.CodigoEdi]: valor,
                    }))
                  }
                  createPopupQuestion={createPopupQuestion}
                  removePopupQuestion={removePopupQuestion}
                />
              ))}
            </div>
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Aceptar"
                disabled={!puedeAceptar}
                onClick={() => onAccept(buildParametrosGuardados())}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};
